import { useEffect, useState } from 'react';
import type { Connection, HassConfig } from 'home-assistant-js-websocket';
import { subscribeConfig } from 'home-assistant-js-websocket';

export function useHAConfig(connection: Connection | null): HassConfig | null {
  const [config, setConfig] = useState<HassConfig | null>(null);
  useEffect(() => {
    if (!connection) return;
    const unsub = subscribeConfig(connection, (cfg) => setConfig(cfg));
    return () => {
      unsub();
    };
  }, [connection]);
  return config;
}
